import React, { forwardRef, useId } from "react";
import "./Input.css";

export const Input = forwardRef(function Input(
  {
    label,
    hint,
    error,
    leftIcon,
    rightIcon,
    fullWidth = true,
    id: idProp,
    className = "",
    ...props
  },
  ref
) {
  const reactId = useId();
  const id = idProp || reactId;
  return (
    <div className={`ui-field ${fullWidth ? "ui-field-full" : ""} ${error ? "ui-field-error" : ""} ${className}`}>
      {label && (
        <label htmlFor={id} className="ui-field-label">
          {label}
        </label>
      )}
      <div className="ui-field-control">
        {leftIcon && <span className="ui-field-adornment ui-field-adornment-left">{leftIcon}</span>}
        <input ref={ref} id={id} className="ui-field-input" {...props} />
        {rightIcon && <span className="ui-field-adornment ui-field-adornment-right">{rightIcon}</span>}
      </div>
      {(error || hint) && (
        <span className={`ui-field-help ${error ? "ui-field-help-error" : ""}`}>
          {error || hint}
        </span>
      )}
    </div>
  );
});

export const Textarea = forwardRef(function Textarea(
  {
    label,
    hint,
    error,
    fullWidth = true,
    rows = 4,
    id: idProp,
    className = "",
    ...props
  },
  ref
) {
  const reactId = useId();
  const id = idProp || reactId;
  return (
    <div className={`ui-field ${fullWidth ? "ui-field-full" : ""} ${error ? "ui-field-error" : ""} ${className}`}>
      {label && (
        <label htmlFor={id} className="ui-field-label">
          {label}
        </label>
      )}
      <div className="ui-field-control ui-field-control-textarea">
        <textarea ref={ref} id={id} rows={rows} className="ui-field-input ui-field-input-textarea" {...props} />
      </div>
      {(error || hint) && (
        <span className={`ui-field-help ${error ? "ui-field-help-error" : ""}`}>
          {error || hint}
        </span>
      )}
    </div>
  );
});
